import axios from "axios";

const api = axios.create({
    baseURL: "https://api2.saasoftware.com.br/saadash/api/dash",
});

export default api;
